// A rejected autoplay request leaves the media paused; it is not a media error.
export function playSafely(player) {
  if (!player || player.isDisposed?.()) return Promise.resolve(false);
  try {
    return Promise.resolve(player.play()).then(
      () => !player.isDisposed?.() && !player.paused(),
      () => false
    );
  } catch (_) {
    return Promise.resolve(false);
  }
}
